import {
    validationDefault,
    validationDefaultNew,
} from '../../components/utilities/rulesUtilities';
import genericOptions from '../defaultConfigRole/genericOptions';
import genericColumnsCalculatorEmployee from '../../config/defaultConfigRole/genericColumnsCalculatorEmployees';
import requestsListStatusEmployees from './requestsListStatusEmployees';
import { PROPERTIES, URL } from '../../constants/constantValues';

const Rules = {
    role_aee81d56a2784a628bc51ae6dedb06c4: {
        home: 'employees',
        requestsListStatusEmployees,
        views: {
            create: {
                titleRequestCredit: 'Crédito para empleados',
                permisions: ['createRequestCredit', 'listRequestCredit'],
                resumenInformation: true,
                components: [
                    {
                        name: 'Solicitante',
                        component: ['InformationClient'],
                    },
                    {
                        name: 'Contacto',
                        component: ['ContactsClient'],
                    },
                    {
                        name: 'Inf. Crédito',
                        component: [
                            'InformationCreditEmployees',
                            'CalculatorCreditEmployee',
                        ],
                    },
                    { name: 'Documentos', component: ['DocumentsCredit'] },
                ],
                actionStatus: ['desistir', 'resumen', 'anotaciones'],
                actionStatusAll: ['resumen', 'anotaciones'],
                causalType: 1,
                groupUser: 2,
            },
            consult: {
                permisions: [
                    'consultClientList',
                    'ConsultClientEdit',
                    'InformationCredit:edit',
                    'consultClientView',
                ],
                components: [
                    {
                        name: 'Solicitante',
                        component: ['InformationClient'],
                    },
                    { name: 'Contacto', component: ['ContactsClient'] },
                    { name: 'Documentos', component: ['DocumentsClient'] },
                    {
                        name: 'Solicitudes cliente',
                        component: ['RequestsClient'],
                    },
                    { name: 'Crédito', component: ['GygClient'] },
                ],
                noShowFieldsConsult: true,
            },
            profile: {
                fields: [
                    {
                        name: 'identification_number',
                        label: 'Número de identificación',
                        disabled: false,
                        type: 'integer',
                        col: 6,
                        validation: validationDefaultNew(
                            [
                                { type: 'required', value: true },
                                { type: 'maxLength', value: 12 },
                                { type: 'minLength', value: 6 },
                            ],
                            'número de identificacion'
                        ),
                    },
                    {
                        name: 'first_name',
                        label: 'Nombres',
                        disabled: false,
                        type: 'string',
                        col: 6,
                        validation: validationDefaultNew(
                            [{ type: 'required', value: true }],
                            'nombres'
                        ),
                    },
                    {
                        name: 'last_name',
                        label: 'Apellidos',
                        disabled: false,
                        type: 'string',
                        col: 6,
                        validation: validationDefaultNew(
                            [{ type: 'required', value: true }],
                            'apellidos'
                        ),
                    },
                    {
                        name: 'phone_number',
                        label: 'Número telefónico',
                        disabled: false,
                        type: 'celular',
                        col: 6,
                        validation: validationDefaultNew(
                            [{ type: 'required', value: true }],
                            'número telefónico'
                        ),
                    },
                ],
            },
        },
        components: {
            informationClient: {
                tittle: 'solicitante',
                permisions: [
                    'informationClient:list',
                    'informationClient:edit',
                ],
                fields: [
                    {
                        name: 'tipo_identificacion',
                        label: 'Tipo identificación',
                        disabled: false,
                        type: 'select',
                        col: 3,
                        options: genericOptions.tipo_de_documento,
                        validation: validationDefault(
                            ['required'],
                            'tipo de documento'
                        ),
                    },
                    {
                        label: 'Número de identificación',
                        name: 'numero_identificacion',
                        disabled: true,
                        type: 'integer',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                { type: 'required', value: true },
                                { type: 'maxLength', value: 10 },
                                { type: 'minLength', value: 6 },
                            ],
                            'número de identificación'
                        ),
                    },
                    {
                        name: 'primer_nombre',
                        disabled: false,
                        type: 'string',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                { type: 'required', value: true },
                                { type: 'maxLength', value: 25 },
                                { type: 'minLength', value: 3 },
                            ],
                            'primer nombre'
                        ),
                    },
                    {
                        name: 'segundo_nombre',
                        disabled: false,
                        type: 'string',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                { type: 'maxLength', value: 25 },
                                { type: 'minLength', value: 3 },
                            ],
                            'segundo nombre'
                        ),
                    },
                    {
                        name: 'primer_apellido',
                        disabled: false,
                        type: 'string',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                { type: 'required', value: true },
                                { type: 'maxLength', value: 25 },
                                { type: 'minLength', value: 2 },
                            ],
                            'primer apellido'
                        ),
                    },
                    {
                        name: 'segundo_apellido',
                        disabled: false,
                        type: 'string',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                { type: 'maxLength', value: 25 },
                                { type: 'minLength', value: 2 },
                            ],
                            'segundo apellido'
                        ),
                    },
                    {
                        name: 'genero',
                        label: 'Género',
                        disabled: false,
                        type: 'select',
                        col: 3,
                        options: genericOptions.genero,
                        validation: validationDefault(['required'], 'genero'),
                    },
                    {
                        name: 'lugar_expedicion_documento',
                        label: 'Lugar expedición documento',
                        disabled: false,
                        type: 'autocomplete',
                        col: 3,
                        options: [],
                        url: URL.CIUDADES.value,
                        validation: validationDefault(
                            ['required'],
                            'lugar de expedición documento'
                        ),
                    },
                    {
                        name: 'fecha_expedicion_documento',
                        label: 'Fecha expedición documento',
                        disabled: false,
                        type: 'date',
                        col: 3,
                        validation: validationDefault(
                            ['required'],
                            'fecha de expedición del documento'
                        ),
                    },
                    {
                        name: 'lugar_nacimiento',
                        disabled: false,
                        type: 'autocomplete',
                        col: 3,
                        options: [],
                        url: URL.CIUDADES.value,
                        validation: validationDefault(
                            ['required'],
                            'lugar de nacimiento'
                        ),
                    },
                    {
                        name: 'fecha_nacimiento',
                        disabled: false,
                        type: 'date',
                        col: 3,
                        validation: validationDefault(
                            ['required'],
                            'fecha de nacimiento'
                        ),
                    },
                    {
                        name: 'estado_civil',
                        disabled: false,
                        type: 'select',
                        col: 3,
                        options: genericOptions.estado_civil,
                        validation: validationDefault(
                            ['required'],
                            'estado civil'
                        ),
                    },
                ],
            },
            productCredit: {
                permisions: ['productCredit:list', 'productCredit:edit'],
                fields: [],
                filedsConditional: {
                    p1: [
                        {
                            name: 'monto_aprobado',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto aprobado'
                            ),
                        },
                        {
                            name: 'plazo',
                            label: 'Plazo solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'empleado_credito_producto',
                            url: '/empleado_credito_calculadora/plazo_producto_credito/',
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                        {
                            name: 'numero_cuenta_bancaria',
                            label: 'Número de cuenta',
                            disabled: false,
                            type: 'integer',
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    { type: 'required', value: true },
                                    { type: 'maxLength', value: 15 },
                                    { type: 'minLength', value: 6 },
                                ],
                                'número de cuenta'
                            ),
                        },
                        {
                            name: 'banco',
                            label: 'Entidad bancaria',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.BANCOS.value,
                            validation: validationDefault(
                                ['required'],
                                'entidad bancaria'
                            ),
                        },
                        {
                            name: 'ciudad_banco',
                            label: 'Ciudad banco',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'Ciudad banco'
                            ),
                        },
                        {
                            name: 'tipo_cuenta',
                            label: 'Tipo cuenta',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            options: genericOptions.tipo_cuenta,
                            validation: validationDefault(
                                ['required'],
                                'Tipo cuenta'
                            ),
                        },
                        {
                            name: 'tipo_credito',
                            label: 'Tipo de credito',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            options: genericOptions.tipo_credito_empleados,
                            validation: validationDefault(
                                ['required'],
                                'Tipo cuenta'
                            ),
                        },
                        {
                            name: 'dia_de_pago',
                            label: 'Día de pago',
                            disabled: false,
                            type: 'integer',
                            options: genericOptions.dia_de_pago,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    { type: 'required', value: true },
                                    { type: 'min', value: 1 },
                                    { type: 'max', value: 31 },
                                ],
                                'día de pago'
                            ),
                        },
                        {
                            name: 'empleado_credito_sede',
                            label: 'Sede',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            options: [],
                            url: '/globals/empleado_credito_sede/',
                            validation: validationDefault(['required'], 'sede'),
                        },
                        {
                            name: 'empleado_credito_area',
                            label: 'Área',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            options: [],
                            url: '/globals/empleado_credito_area/',
                            validation: validationDefault(['required'], 'area'),
                        },
                        {
                            name: 'aprobado_por',
                            label: 'Aprobado por',
                            disabled: false,
                            type: 'string',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'aprobado'
                            ),
                        },
                        {
                            name: 'tipo_garantia',
                            label: 'Garantías',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            options: genericOptions.garantia_Empleado,
                            validation: validationDefault(
                                ['required'],
                                'garantias'
                            ),
                        },
                        {
                            name: 'recoge_saldo',
                            disabled: false,
                            type: 'switch',
                            typeColumn: 2,
                            col: 2,
                            validation: validationDefault(
                                ['required'],
                                'recoger saldo'
                            ),
                        },
                    ],
                    p2: [
                        {
                            name: 'empleado_credito_categoria_educativa',
                            label: 'Categoría educativa',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            options: [],
                            parentDependency: true,
                            url: '/globals/empleado_credito_categoria_educativa/',
                            validation: validationDefault(
                                ['required'],
                                'categoría educativa'
                            ),
                        },
                        {
                            name: 'monto_aprobado',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto aprobado'
                            ),
                        },
                        {
                            name: 'plazo',
                            label: 'Plazo solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'empleado_credito_categoria_educativa',
                            url: '/empleado_credito_calculadora/plazo_producto_credito/?empleado_credito_producto=2',
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                        {
                            name: 'numero_cuenta_bancaria',
                            label: 'Número de cuenta',
                            disabled: false,
                            type: 'integer',
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    { type: 'required', value: true },
                                    { type: 'maxLength', value: 15 },
                                    { type: 'minLength', value: 6 },
                                ],
                                'número de cuenta'
                            ),
                        },
                        {
                            name: 'banco',
                            label: 'Entidad bancaria',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.BANCOS.value,
                            validation: validationDefault(
                                ['required'],
                                'entidad bancaria'
                            ),
                        },
                        {
                            name: 'ciudad_banco',
                            label: 'Ciudad banco',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'Ciudad banco'
                            ),
                        },
                        {
                            name: 'tipo_cuenta',
                            label: 'Tipo cuenta',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            options: genericOptions.tipo_cuenta,
                            validation: validationDefault(
                                ['required'],
                                'Tipo cuenta'
                            ),
                        },
                        {
                            name: 'tipo_credito',
                            label: 'Tipo de credito',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            options: genericOptions.tipo_credito_empleados,
                            validation: validationDefault(
                                ['required'],
                                'Tipo cuenta'
                            ),
                        },
                        {
                            name: 'dia_de_pago',
                            label: 'Día de pago',
                            disabled: false,
                            type: 'integer',
                            options: genericOptions.dia_de_pago,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    { type: 'required', value: true },
                                    { type: 'min', value: 1 },
                                    { type: 'max', value: 31 },
                                ],
                                'día de pago'
                            ),
                        },
                        {
                            name: 'empleado_credito_sede',
                            label: 'Sede',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            options: [],
                            url: '/globals/empleado_credito_sede/',
                            validation: validationDefault(['required'], 'sede'),
                        },
                        {
                            name: 'empleado_credito_area',
                            label: 'Área',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            options: [],
                            url: '/globals/empleado_credito_area/',
                            validation: validationDefault(['required'], 'area'),
                        },
                        {
                            name: 'aprobado_por',
                            label: 'Aprobado por',
                            disabled: false,
                            type: 'string',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'aprobado'
                            ),
                        },
                        {
                            name: 'tipo_garantia',
                            label: 'Garantías',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            options: genericOptions.garantia_Empleado,
                            validation: validationDefault(
                                ['required'],
                                'garantias'
                            ),
                        },
                        {
                            name: 'recoge_saldo',
                            disabled: false,
                            type: 'switch',
                            typeColumn: 2,
                            col: 2,
                            validation: validationDefault(
                                ['required'],
                                'recoger saldo'
                            ),
                        },
                    ],
                },
            },
            contactsClient: {
                permisions: [
                    'contactsClient:list',
                    'contactsClient:edit',
                    'contactsClient:editButton',
                    'contactsClient:editButtonConsult',
                ],
                tittle: 'solicitante',
                fields: [
                    {
                        name: 'ciudad_contacto',
                        label: 'Ciudad',
                        disabled: false,
                        type: 'autocomplete-dependency',
                        col: 6,
                        showTable: true,
                        options: [],
                        parentDependency: true,
                        childrenDependency: 'barrio_contacto',
                        url: URL.CIUDADES.value,
                        validation: validationDefault(
                            ['required'],
                            'ciudad de contacto'
                        ),
                    },
                    {
                        name: 'barrio_contacto',
                        disabled: false,
                        type: 'select',
                        col: 6,
                        showTable: true,
                        dependency: 'ciudad_contacto',
                        options: [],
                        url: URL.BARRIOS.value,
                        validation: validationDefault(
                            ['required'],
                            'barrio del contacto'
                        ),
                    },
                    {
                        name: 'direccion',
                        label: 'Dirección',
                        disabled: false,
                        type: 'addressComplement',
                        staticCol: 12,
                        showTable: true,
                        validation: validationDefaultNew(
                            [
                                { type: 'required', value: true },
                                { type: 'maxLength', value: 255 },
                                { type: 'minLength', value: 2 },
                            ],
                            'dirección'
                        ),
                    },
                    {
                        name: 'referencia_ubicacion',
                        label: 'Referencia ubicación',
                        disabled: false,
                        type: 'string',
                        col: 6,
                        showTable: true,
                    },

                    {
                        name: 'telefono',
                        label: 'Teléfono',
                        disabled: false,
                        type: 'phone',
                        col: 6,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'pattern',
                                    value: PROPERTIES.PHONE.regExp,
                                    mesagge:
                                        'El número ingresado no es un número válido',
                                },
                            ],
                            'teléfono'
                        ),
                    },
                    {
                        name: 'celular',
                        label: 'Celular',
                        disabled: false,
                        type: 'celular',
                        col: 6,
                        showTable: true,
                        validation: validationDefault(['required'], 'celular'),
                    },
                    {
                        name: 'correo_electronico',
                        label: 'Correo electrónico',
                        disabled: false,
                        type: 'email',
                        col: 6,
                        showTable: true,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'pattern',
                                    value: PROPERTIES.EMAIL.regExp,
                                    mesagge:
                                        'El correo electrónico ingresado no es válido',
                                },
                                {
                                    type: 'required',
                                    value: PROPERTIES.EMAIL.required,
                                },
                            ],
                            'correo electrónico'
                        ),
                    },
                    {
                        name: 'principal',
                        label: 'Principal',
                        disabled: false,
                        type: 'select',
                        options: genericOptions.direccion_principal,
                        defaultValue: [],
                        col: 6,
                        showTable: true,
                    },
                ],
                defaultValues: {
                    direccion: 'carrera 1 calle 1 # 1',
                    barrio: 'Ciudad modelo',
                    latitud: '11111324',
                    longitud: '38947239',
                    telefono: '',
                    celular: '',
                    correo_electronico: 'test@finamiga.co',
                    referencia_ubicacion: 'cerca a... diagonal a...',
                    tipo_ubicacion: 1,
                    departamento: 5,
                    ciudad_contacto: 1205,
                },
            },
            informationCreditEmployees: {
                permisions: [
                    'informationCreditEmployees:list',
                    'informationCreditEmployees:edit',
                ],
                fields: [
                    {
                        name: 'empleado_credito_producto',
                        label: 'Producto',
                        disabled: false,
                        type: 'select',
                        col: 3,
                        parentDependency: true,
                        url: '/globals/empleado_credito_producto/',
                        validation: validationDefault(['required'], 'producto'),
                    },
                ],
                fieldsDynamic: [],
                filedsConditional: {
                    p1: [
                        {
                            name: 'monto_aprobado',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto aprobado'
                            ),
                        },
                        {
                            name: 'plazo',
                            label: 'Plazo solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'empleado_credito_producto',
                            url: '/empleado_credito_calculadora/plazo_producto_credito/',
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                        {
                            name: 'numero_cuenta_bancaria',
                            label: 'Número de cuenta',
                            disabled: false,
                            type: 'integer',
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    { type: 'required', value: true },
                                    { type: 'maxLength', value: 15 },
                                    { type: 'minLength', value: 6 },
                                ],
                                'número de cuenta'
                            ),
                        },
                        {
                            name: 'banco',
                            label: 'Entidad bancaria',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.BANCOS.value,
                            validation: validationDefault(
                                ['required'],
                                'entidad bancaria'
                            ),
                        },
                        {
                            name: 'ciudad_banco',
                            label: 'Ciudad banco',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'Ciudad banco'
                            ),
                        },
                        {
                            name: 'tipo_cuenta',
                            label: 'Tipo cuenta',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            options: genericOptions.tipo_cuenta,
                            validation: validationDefault(
                                ['required'],
                                'Tipo cuenta'
                            ),
                        },
                        {
                            name: 'tipo_credito',
                            label: 'Tipo de credito',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            options: genericOptions.tipo_credito_empleados,
                            validation: validationDefault(
                                ['required'],
                                'Tipo cuenta'
                            ),
                        },
                        {
                            name: 'dia_de_pago',
                            label: 'Día de pago',
                            disabled: false,
                            type: 'integer',
                            options: genericOptions.dia_de_pago,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    { type: 'required', value: true },
                                    { type: 'min', value: 1 },
                                    { type: 'max', value: 31 },
                                ],
                                'día de pago'
                            ),
                        },
                        {
                            name: 'empleado_credito_sede',
                            label: 'Sede',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            options: [],
                            url: '/globals/empleado_credito_sede/',
                            validation: validationDefault(['required'], 'sede'),
                        },
                        {
                            name: 'empleado_credito_area',
                            label: 'Área',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            options: [],
                            url: '/globals/empleado_credito_area/',
                            validation: validationDefault(['required'], 'area'),
                        },
                        {
                            name: 'aprobado_por',
                            label: 'Aprobado por',
                            disabled: false,
                            type: 'string',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'aprobado'
                            ),
                        },
                        {
                            name: 'tipo_garantia',
                            label: 'Garantías',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            options: genericOptions.garantia_Empleado,
                            validation: validationDefault(
                                ['required'],
                                'garantias'
                            ),
                        },
                        {
                            name: 'recoge_saldo',
                            disabled: false,
                            type: 'switch',
                            typeColumn: 2,
                            col: 2,
                            validation: validationDefault(
                                ['required'],
                                'recoger saldo'
                            ),
                        },
                    ],
                    p2: [
                        {
                            name: 'empleado_credito_categoria_educativa',
                            label: 'Categoría educativa',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            options: [],
                            parentDependency: true,
                            url: '/globals/empleado_credito_categoria_educativa/',
                            validation: validationDefault(
                                ['required'],
                                'categoría educativa'
                            ),
                        },
                        {
                            name: 'monto_aprobado',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto aprobado'
                            ),
                        },
                        {
                            name: 'plazo',
                            label: 'Plazo solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'empleado_credito_categoria_educativa',
                            url: '/empleado_credito_calculadora/plazo_producto_credito/?empleado_credito_producto=2',
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                        {
                            name: 'numero_cuenta_bancaria',
                            label: 'Número de cuenta',
                            disabled: false,
                            type: 'integer',
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    { type: 'required', value: true },
                                    { type: 'maxLength', value: 15 },
                                    { type: 'minLength', value: 6 },
                                ],
                                'número de cuenta'
                            ),
                        },
                        {
                            name: 'banco',
                            label: 'Entidad bancaria',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.BANCOS.value,
                            validation: validationDefault(
                                ['required'],
                                'entidad bancaria'
                            ),
                        },
                        {
                            name: 'ciudad_banco',
                            label: 'Ciudad banco',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'Ciudad banco'
                            ),
                        },
                        {
                            name: 'tipo_cuenta',
                            label: 'Tipo cuenta',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            options: genericOptions.tipo_cuenta,
                            validation: validationDefault(
                                ['required'],
                                'Tipo cuenta'
                            ),
                        },
                        {
                            name: 'tipo_credito',
                            label: 'Tipo de credito',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            options: genericOptions.tipo_credito_empleados,
                            validation: validationDefault(
                                ['required'],
                                'Tipo cuenta'
                            ),
                        },
                        {
                            name: 'dia_de_pago',
                            label: 'Día de pago',
                            disabled: false,
                            type: 'integer',
                            options: genericOptions.dia_de_pago,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    { type: 'required', value: true },
                                    { type: 'min', value: 1 },
                                    { type: 'max', value: 31 },
                                ],
                                'día de pago'
                            ),
                        },
                        {
                            name: 'empleado_credito_sede',
                            label: 'Sede',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            options: [],
                            url: '/globals/empleado_credito_sede/',
                            validation: validationDefault(['required'], 'sede'),
                        },
                        {
                            name: 'empleado_credito_area',
                            label: 'Área',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            options: [],
                            url: '/globals/empleado_credito_area/',
                            validation: validationDefault(['required'], 'area'),
                        },
                        {
                            name: 'aprobado_por',
                            label: 'Aprobado por',
                            disabled: false,
                            type: 'string',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'aprobado'
                            ),
                        },
                        {
                            name: 'tipo_garantia',
                            label: 'Garantías',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            options: genericOptions.garantia_Empleado,
                            validation: validationDefault(
                                ['required'],
                                'garantias'
                            ),
                        },
                        {
                            name: 'recoge_saldo',
                            disabled: false,
                            type: 'switch',
                            typeColumn: 2,
                            col: 2,
                            validation: validationDefault(
                                ['required'],
                                'recoger saldo'
                            ),
                        },
                    ],
                },
                defaultValues: {
                    monto_aprobado: 5000000,
                    plazo: 2,
                    valor_mensual: null,
                    valor_seguro: null,
                    valor_total: null,
                    numero_cuenta_bancaria: 12345678910,
                    banco: null,
                    ciudad_banco: null,
                    tipo_cuenta: null,
                },
            },
            CalculatorCreditEmployee: {
                permisions: [
                    'CalculatorCreditEmployee:list',
                    'CalculatorCreditEmployee:edit',
                    'CalculatorCreditEmployee:simulator',
                ],
                summaryCredit: genericColumnsCalculatorEmployee.summaryCredit,
                monthlyValues: genericColumnsCalculatorEmployee.monthlyValues,
            },
            documentsCredit: {
                permisions: ['documentsCredit:list', 'documentsCredit:edit'],
                fields: [
                    {
                        name: 'empleado_credito_tipo_documento',
                        label: 'Tipo documento',
                        disabled: false,
                        type: 'select',
                        col: 5,
                        options: [],
                        url: '/globals/empleado_credito_tipo_documento/',
                        showTable: true,
                        notSearchGlobals: true,
                        validation: validationDefault(
                            ['required'],
                            'tipo de documento'
                        ),
                    },
                    {
                        name: 'documento',
                        disabled: false,
                        type: 'file',
                        col: 5,
                        validation: validationDefault(
                            ['required'],
                            'documento'
                        ),
                    },
                ],
            },
            observationCredit: {
                permisions: [
                    'observationCredit:list',
                    'observationCredit:edit',
                ],
                fields: [
                    {
                        className: 'input-observacion',
                        name: 'observacion',
                        label: 'Observación',
                        disabled: false,
                        type: 'string',
                        rows: 1,
                        typeColumn: 2,
                        col: 12,
                        showTable: true,
                        staticCol: 12,
                        validation: validationDefault(
                            ['required'],
                            'observación'
                        ),
                    },
                ],
            },
            reportsGeneral: {
                fields: [
                    {
                        name: 'tipo_reporte',
                        disabled: false,
                        type: 'select',
                        col: 4,
                        url: '/globals/gestor_reportes/?rol=27',
                        notSearchGlobals: true,
                    },
                    {
                        name: 'fecha_desde',
                        label: 'Fecha desde',
                        disabled: false,
                        type: 'date',
                        col: 4,
                        validation: {
                            required: {
                                value: true,
                                message: 'La fecha desde es obligatoria',
                            },
                        },
                    },
                    {
                        name: 'fecha_hasta',
                        label: 'Fecha hasta',
                        disabled: false,
                        type: 'date',
                        col: 4,
                        validation: {
                            required: {
                                value: true,
                                message: 'La fecha hasta es obligatoria',
                            },
                        },
                    },
                    {
                        name: 'productos',
                        disabled: false,
                        type: 'select-multiple',
                        col: 4,
                        url: '/globals/productos/',
                    },
                ],
            },
            documentsHumans: {
                permisions: ['documentsHumans:list'],
                fields: [
                    {
                        name: 'empleado_credito_tipo_documento',
                        label: 'Tipo documento',
                        disabled: false,
                        type: 'select',
                        col: 5,
                        url: '/globals/empleado_credito_tipo_documento/',
                        showTable: true,
                        notSearchGlobals: true,
                        validation: validationDefault(
                            ['required'],
                            'tipo de documento'
                        ),
                    },
                    {
                        name: 'documento',
                        disabled: false,
                        type: 'file',
                        col: 5,
                        validation: validationDefault(
                            ['required'],
                            'documento'
                        ),
                    },
                ],
            },
        },
    },
};

export default Rules;
